import styled from 'styled-components'

export const Text = styled.div`
  font-size: 16px;
  font-weight: var(--font-regular);
  line-height: 1.8;

  em {
    font-style: italic;
  }

  strong {
    font-weight: var(--font-bold);
  }

  p {
    margin-bottom: 25px;
  }

  ul {
    list-style: disc;
  }
  ol {
    list-style: numeric;
  }
  ol,
  ul {
    margin: 15px 0;
    padding-left: 20px;
  }

  code {
    white-space: pre-line;
    font-weight: Menlo, Consolas, Monaco, Liberation Mono, Lucida Console, monospace;
    padding: 8px 10px;
    line-height: 1.6;
    border-radius: 4px;
    background: #f2f1f1;
    font-size: 15px;
    margin: 10px 0;
    display: inline-block;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`
